import Handler from "../Handler";
class RITRevealCardHandler extends Handler {
    execute(message) {
      let receivedData = JSON.parse(message);
      this.service.processRITRevealCard(receivedData);
    }
  }
  
  export default RITRevealCardHandler;